export const COUNTRY = {
  DATA_FOR: 'country-filter-value',
  MAX_OPTIONS_TO_SHOW: 1,
  GB: 'GB',
  UK: 'UK',
  SELECT_OPTION: "select-option"
}